import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { UploadService } from '../../services/upload/upload.service';
import { environment } from '../../../environments/environment';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-firm-response-evaluation',
  standalone: false,
  templateUrl: './firm-response-evaluation.component.html',
})
export class FirmResponseEvaluationComponent
  implements OnInit
{
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() stepDetails: any;
  @Input() type: string = '';
  @Input() url: string = '';
  @Input() schemeType: string = '';
  PraposalName: any;
  evaluationData: any;
  vendorList: any;
  hpscFormEveluation= new FormGroup({
    id: new FormControl(null),
    title: new FormControl('',[Validators.required]),
    name_evaluator: new FormControl('',[Validators.required]),
    category: new FormControl('',[Validators.required]),
    org_evaluator: new FormControl('', [Validators.required]),
    nodal_agecy: new FormControl(''),
    contact_detail: new FormControl('', [
      Validators.required,
      Validators.pattern(/^(\+91[\-\s]?)?[6-9]\d{9}$/)
    ]),
    date_evaluator: new FormControl('', [Validators.required]),
    email_id: new FormControl('', [Validators.required, Validators.email]),
}); 
  
  tableColumns: any[] = [
    { field: 'vendor.name', header: 'Shortlisted Applicants/Proposals', type: 'text', isEditable: false },
    { field: 'vendor.company_name', header: 'Company Name', type: 'text', isEditable: false },
    { field: 'vendor_status', header: 'Status', type: 'status', isEditable: false },
    { field: 'ref_dio', header: 'Rep DIO/iDEX(60)', type: 'number', isEditable: true ,maxVal:10 },
    { field: 'ref_incubator', header: 'Rep Partner Incubator(60)', type: 'number', isEditable: true ,maxVal:10 },
    { field: 'ref_academia', header: 'Rep Academia(60)', type: 'number', isEditable: true ,maxVal:10 },
    { field: 'ref_industry', header: 'Rep Industry(60)', type: 'number', isEditable: true ,maxVal:10 },
    { field: 'nodal_officer', header: 'Nodal Officer(60)', type: 'number', isEditable: true ,maxVal:10 },
    // { field: 'viability', header: 'Viability(10)', type: 'number', isEditable: true ,maxVal:10 },
    { field: 'total', header: 'Total(300)', type: 'number', isEditable: false ,maxVal:60 },
    { field: 'percentage', header: 'Percentage (%)', type: 'number', isEditable: false ,maxVal:100 },
    { field: 'remarks', header: 'Remarks', type: 'textarea', isEditable: true },
  ];

  selectedProposals = []
  constructor(
    private messageService: MessageService,  private fb: FormBuilder,  private api: ApiService,
    private uploadService: UploadService,  private route: ActivatedRoute
  ) {
    
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalName = params['name'];
      this.PraposalName = proposalName;
      
    })
    this.getEvaluationData();
  }

  getPdf(){

  }

  getEvaluationData(){
    this.api.getAPI(`/idex/evaluation/?proposal_step__proposal=${this.stepDetails.proposal}&proposal_step=${this.stepDetails.id}`).subscribe((resp: any) => {
      this.evaluationData = resp;
        this.hpscFormEveluation.patchValue(resp);
        this.hpscFormEveluation.get('name_evaluator')?.enable();
        this.hpscFormEveluation.get('org_evaluator')?.enable();
        this.hpscFormEveluation.get('contact_detail')?.enable();
        this.hpscFormEveluation.get('date_evaluator')?.enable();
        this.hpscFormEveluation.get('email_id')?.enable();
        this.hpscFormEveluation.get('id')?.enable();
      
        const vendorMap = resp?.vender || resp?.vendor || {};
        this.vendorList = Object.values(vendorMap).flat();
    });
  }

  onSubmitHpscForm() {
    console.log(this.hpscFormEveluation);
  
    if (this.hpscFormEveluation.invalid) {
      this.hpscFormEveluation.markAllAsTouched();
      const errorMsg = this.getFormErrorMessage();
      this.messageService.add({  severity: 'warn',  summary: 'Validation Error',  detail: errorMsg,
      });
      return;
    }

    const formData = this.hpscFormEveluation.value;
    this.api.putAPI(`/idex/evaluation/${formData?.id}/`, formData).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail:res.message || 'Evaluation updated successfully' });
      this.getEvaluationData();
    });
  }
  private getFormErrorMessage(): string {
    const ctrlLabelMap: { [key: string]: string } = {
      title: 'Challenge Title',
      name_evaluator: 'Name of Evaluator',
      category: 'Category',
      org_evaluator: 'Organisation of Evaluator',
      nodal_agecy: 'Nodal Agency',
      contact_detail: 'Contact Details',
      date_evaluator: 'Date of Evaluation',
      email_id: 'Email ID'
    };
    const invalidFields: string[] = [];
    Object.keys(this.hpscFormEveluation.controls).forEach(key => {
      const control = this.hpscFormEveluation.get(key);
      if (control && control.invalid) {  invalidFields.push(ctrlLabelMap[key] || key);  }
    });
    if (!invalidFields.length) {
      return 'Please fill in all required fields.';
    }
    return 'Please correct the following fields: ' + invalidFields.join(', ');
  }
  autoLineUpdate(event: any) {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto'; // Reset the height
    textarea.style.height = `${textarea.scrollHeight}px`; // Set it to scrollHeight (fits content)
  }
getNestedData(obj: any, path: string | string[]): any {
  if (!obj || !path) return undefined;
  const keys = Array.isArray(path) ? path : path.split('.');
  let result = obj;
  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      return undefined;
    }
  }
  return result;
}
onRowSave(proposal: any) {
  const rowdata={...proposal, vendor_eval_id: proposal.id}
    delete rowdata.vendor, delete rowdata.isEditable, delete rowdata.vendor_status; delete rowdata.id
  this.api.putAPI(`/idex/evaluation/`, rowdata).subscribe((res: any) => {
    this.messageService.add({ severity: 'success', summary: 'Success', detail:res.message || 'Evaluation updated successfully' });
    this.getEvaluationData();
  });
}

onNumberInput(event: any, proposal: any, field: string) {
  const value = event.target.value;
  if (value < 0) {
    event.target.value = 0;
    return;
  }
  if (value > proposal[field].maxVal) {
    event.target.value = proposal[field].maxVal;
    return;
  }
}

changeStatus(status: 'Qualify' | 'Disqualify') {
  // Iterate over each selected proposal and update one by one
  this.selectedProposals.forEach((proposal, idx) => {
    const payload = {
      vendor_status: status,
      vendor_eval_id: proposal.id
    };
    this.api.putAPI(`/idex/evaluation/`, payload).subscribe((res: any) => {
      // Call getEvaluationData only after the last
      if (idx === this.selectedProposals.length - 1) {
        this.messageService.add({ severity: 'success', summary: 'Success', detail:res.message || 'Evaluation updated successfully' });
        this.getEvaluationData();
        this.selectedProposals = [];
      }
    });
  });
}
getHPSCStatus(status: string): string {
  switch (status) {
    case 'Qualify':
      return 'HPSC Recommended';
    case 'Disqualify':
      return 'HPSC Not Recommended';
    default:
      return 'Ongoing Evaluation';
  }
}
}
